export default [
    '24 24',
    '<path d="M18 17L13 12L18 7M11 17L6 12L11 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]